const positions = [
    {
        id: 1,
        type: "Full-time",
        location: "On-site",
        title: "Subject Matter Expert (SME) – Signal Automation (Railways)",
        description: "We’re looking for an SME in railway signaling and automation to guide product development, compliance, and client solutioning. You'll bridge technical design and railway standards.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },




    {
        id: 2,
        type: "Full-time",
        location: "On-site",
        title: "Mechanical Engineer",
        description: "As a Mechanical Engineer, you’ll support the design, simulation, and prototyping of enclosures, moving parts, and mechanical assemblies used in automation products and industrial systems.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },





    {
        id: 3,
        type: "Full-time",
        location: "On-site",
        title: "Project Execution Engineer – Commissioning at Site",
        description: "We’re hiring a hands-on Project Execution Engineer to handle on-site commissioning, testing, and deployment of automation systems, with a focus on railway or industrial applications.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },





    {
        id: 4,
        type: "Full-time",
        location: "On-site",
        title: "Electronics Design Engineer",
        description: "We’re seeking an Electronics Design Engineer to develop and test PCB-level hardware for embedded and automation systems. You’ll work on schematics, layout, and component selection, prototyping and production teams.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },





    {
        id: 5,
        type: "Full-time",
        location: "On-site",
        title: "Embedded Software Engineer",
        description: "Join our embedded systems team to design low-level firmware and real-time applications for automation and control products. You’ll work on device drivers, communication protocols, and performance tuning.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },





    {
        id: 6,
        type: "Full-time",
        location: "On-site",
        title: "Sales / Business Development Manager – Railways",
        description: "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. identify tenders signaling solutions to government and PSU entities.",
        experience: "0-4 Years",
        industry: "Hardware Engineering",
        department: "Sales & Business Development",
        summary:
            "We’re hiring a Business Development Manager to drive B2G and B2B opportunities in the railway sector. You’ll identify tenders, manage client relationships, and pitch automation and signaling solutions to government and PSU entities.",
        responsibilities: [
            "Generate leads and drive business in railway signaling and automation.",
            "Engage with PSU clients (e.g. Indian Railways, RITES, IRCON).",
            "Track tenders and RFPs, prepare techno-commercial proposals.",
            "Support strategic partnerships and contract negotiations."
        ],
        goodToHave: [
            "Prior exposure to railway domain or industrial automation products.",
            "Experience in CRM tools and tender management platforms."
        ],
        whatWeOffer: [
            "Direct impact on revenue and partnerships.",
            "Incentives and variable pay linked to performance.",
            "Travel support and autonomy in decision-making."
        ],
        qualifications: [
            "B.Tech/MBA or equivalent, with sales experience in engineering sectors.",
            "Strong understanding of government procurement and e-tendering.",
            "Excellent communication and client handling skills."
        ],
        deadline: "Rolling",
        joining: "Within 30 days (preferred)"
    },

];

export default positions;
